import React, {useState} from "react";
import {CardContainer, CardContainerSelected, CardContent, CardDarkHeader, CardLightHeader,} from "./styled";

export const BarekamCard = ({headerLabel, headerAction, content, withDarkHeader, selected, hoverColor = '#F1F1FB', onClick}: BarekamCardProps) => {
    const [hovered, setHovered] = useState(false);

    const Card = () => (
        <>
            {!!withDarkHeader
                ? <CardDarkHeader>
                    {headerLabel}
                    {headerAction || <></>}
                </CardDarkHeader>
                : <CardLightHeader>
                    {headerLabel}
                    {headerAction || <></>}
                </CardLightHeader>
            }

            <CardContent onClick={() => {
                    setHovered(false);
                    onClick && onClick()}}
                style={{cursor: !!onClick ? 'pointer' : 'unset'}}>
                {content}
            </CardContent>
        </>
    )

    if (!!selected) {
        return (
            <CardContainerSelected onMouseEnter={() => setHovered(true)}
                                   onMouseLeave={() => setHovered(false)}
                                   style={{backgroundColor: hovered ? hoverColor : '#FFF'}}>
                <Card/>
            </CardContainerSelected>
        )
    } else {
        return (
            <CardContainer onMouseEnter={() => setHovered(true)}
                           onMouseLeave={() => setHovered(false)}
                           style={{backgroundColor: hovered ? hoverColor : '#FFF'}}>
                <Card/>
            </CardContainer>
        )
    }
}

type BarekamCardProps = {
    headerLabel: JSX.Element,
    headerAction: JSX.Element,
    content: JSX.Element,

    selected?: boolean,
    withDarkHeader?: boolean,
    hoverColor?: string,
    onClick?: () => void,
}